module.exports = __webpack_public_path__ + "static/media/python-development-icon.36083870.svg";